import { useEffect, useState } from "react";
import { getWorldData } from "../api";

export const useWorldData = () => {
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getWorldData()
      .then((res) => {
        setCountries(res.data.countries);
        setRegions(res.data.regions);
      })
      .finally(() => setLoading(false));
  }, []);

  return { countries, regions, loading };
};